// extracted by mini-css-extract-plugin
module.exports = {"activate-for-all-toggle":"activateForAllEvents_activate-for-all-toggle__Hop6f"};